module.exports = __webpack_public_path__ + "media/img/uploads/program-office-icon-us-army-a24e58b324e0b2c1e339b2bf0f8d1b61.png";